<template>
  <div>

    <div style="width: 800px; border: 1px solid #ccc; margin: 0 auto;">
      <div id="printMe"
           style=" width: 700px; margin: 0 auto;">
        <div v-for="num in 2" class="stuBox" style="page-break-after:always;">

          <div class="title flexCloumnSingleCenter">
            <div class="FS18 bold" style="line-height: 50px;">学生住校申请表</div>
          </div>
          <div class="table">
            <el-row class="borderR">
              <el-col :span="6" class="cell cell50">班级</el-col>
              <el-col :span="6" class="cell cell50">{{ detailInfo.class }}</el-col>
              <el-col :span="6" class="cell cell50">姓名</el-col>
              <el-col :span="6" class="cell cell50">{{ detailInfo.stuName }}</el-col>
            </el-row>
            <el-row class="borderR">
              <el-col :span="3" class="cell cell50">性别</el-col>
              <el-col :span="3" class="cell cell50">
                {{ detailInfo.gender == 1 ? '男' : '' }}
                {{ detailInfo.gender == 2 ? '女' : '' }}
                {{ detailInfo.gender == 0 ? '未知' : '' }}
              </el-col>
              <el-col :span="3" class="cell cell50">现居地</el-col>
              <el-col :span="15" class="cell cell50">{{ detailInfo.address }}</el-col>
            </el-row>

            <el-row class="flexStretch borderR">
              <el-col :span="6" class="cell cell50 flexCenter" style="line-height: unset">申请住校<br/>简述<br/></el-col>
              <el-col :span="18">
                <el-row class="cellMore flexCenter" style="padding: 10px;">{{ detailInfo.remark }}</el-row>
              </el-col>
            </el-row>

            <el-row class="cell borderR">
              <el-row class="">
                <el-col :span="1" class="cell50"></el-col>
                <el-col :span="6" class="cell50 flexStart">系部意见:</el-col>
              </el-row>
              <el-row class="">
                <el-col :span="18" class="cell50 flexEnd">负责人签名:</el-col>
              </el-row>
            </el-row>
            <el-row class="cell borderR borderB">
              <el-row class="">
                <el-col :span="1" class="cell50"></el-col>
                <el-col :span="6" class="cell50 flexStart">学工处意见:</el-col>
              </el-row>
              <el-row class="">
                <el-col :span="18" class="cell50 flexEnd">负责人签名:</el-col>
              </el-row>
            </el-row>
            <div style="padding-left: 10px;padding-top: 5px;font-weight: 700;">附：乘坐102路、6路、117路直达到学校</div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      baseInfo: {},
      detailInfo: {},
      id:0,
    }
  },
  mounted() {
    if (this.$route.query) {
      this.id = Number(this.$route.query.id)
      this.getInfo()
    }

  },
  methods: {
    getInfo() {
      let _this = this
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_by_id', {
          id: _this.id,
        }).then(res => {
          _this.baseInfo = res.data
          if (res.data.table_detail) {
            let detail = JSON.parse(res.data.table_detail)
            _this.detailInfo = Object.assign(detail)
          }
          console.log(_this.detailInfo)
          resolve()
        })
      })
    },

  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.flexStretch {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}

.stuBox {
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;

  .posIndex {
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }

  .table {
    width: 100%;
  }

  .borderR {
    border-right: 1px solid #333;
  }

  .borderB {
    border-bottom: 1px solid #333;
  }

  .FS18 {
    font-size: 18px;
  }

  .bold {
    font-weight: 700;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  .cell {
    border-left: 1px solid #333;
    border-top: 1px solid #333;

    min-height: 30px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    font-family: "宋体";
  }

  .cell50 {
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family: "宋体";
  }

  .cellMore {
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    min-height: 50px;
    text-align: left;
    font-size: 14px;
    font-family: "宋体";
  }
}

.uline {
  text-decoration: underline;
}
</style>
